<div class="container-header">
  <div class="title text-center">
    <h2>
      <strong>Usos de Máquinas</strong>
    </h2>
  </div>

  <!-- Filtros -->
  <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
    <button type="button" class="btn" uib-dropdown-toggle>
      {{($ctrl.filters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
      <li role="menuitem" ng-show="$ctrl.filters.gleba">
        <a ng-click="$ctrl.setFilterAttribute('gleba', null)">Todas</a>
      </li>
      <li class="divider" ng-show="$ctrl.filters.gleba"></li>
      <li role="menuitem" ng-repeat="gleba in $ctrl.glebas | orderBy: 'descricao' track by gleba.id">
        <a ng-click="$ctrl.setFilterAttribute('gleba', gleba)">{{::gleba.descricao | capitalize}}</a>
      </li>
    </ul>
  </div>

  <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
    <button type="button" class="btn">
      {{$ctrl.period.periodo || 'Período'}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
      <li role="menuitem" ng-repeat="periodo in $ctrl.filtroPeriodo">
        <a ng-click="$ctrl.setPeriodo(periodo)">{{::periodo.descricao | capitalize}}</a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.openPeriodsFilter()">Customizado</a>
      </li>
    </ul>
  </div>

  <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="$ctrl.operacoes.length > 0">
    <button type="button" class="btn">
      {{$ctrl.filters.operacao.descricao || 'Operação' | capitalize | characters:10}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu-right" uib-dropdown-menu>
      <li ng-show="$ctrl.filters.operacao">
        <a ng-click="$ctrl.setFilterAttribute('operacao', null)">Todas</a>
      </li>
      <li class="divider" ng-show="$ctrl.filters.operacao"></li>
      <li ng-repeat="operacao in $ctrl.operacoes | orderBy: 'descricao' track by operacao.id">
        <a ng-click="$ctrl.setFilterAttribute('operacao', operacao)">{{::operacao.descricao | capitalize}}</a>
      </li>
    </ul>
  </div>

  <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-show="$ctrl.maquinas.length > 0">
    <button type="button" class="btn">
      {{$ctrl.filters.maquina.descricao || 'Máquina' | characters:10}} <span class="caret"></span>
    </button>
    <ul class="dropdown-menu-right" uib-dropdown-menu>
      <li ng-show="$ctrl.filters.maquina">
        <a ng-click="$ctrl.setFilterAttribute('maquina', null)">Todas</a>
      </li>
      <li class="divider" ng-show="$ctrl.filters.maquina"></li>
      <li ng-repeat="maquina in $ctrl.maquinas | orderBy: 'descricao' track by maquina.id">
        <a ng-click="$ctrl.setFilterAttribute('maquina', maquina)">{{::maquina.descricao}}</a>
      </li>
    </ul>
  </div>
  <!-- Fim Filtros -->
  <br><br>
</div>
<div class="painel-maquinas-wrapper width-100 height-100">
  <p class="text-center margin text-cinza" ng-show="$ctrl.loading">
    <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
  </p>
  <div class="container-body aplicacoes-historicos">
    <p class="text-center margin" ng-show="!$ctrl.loading && $ctrl.usosMaquinas.length < 1">
      Nenhum uso de máquina encontrado para esses filtros.
    </p>
    <uib-accordion close-others="true" class="list-usos-maquinas panel-group" ng-show="$ctrl.usosMaquinas.length && !$ctrl.loading">
      <div infinite-scroll="$ctrl.getUsoMaquinas()" infinite-scroll-parent="true">
        <p class="day-label" ng-repeat-start="uso in $ctrl.usosMaquinas track by uso.id" ng-if="$ctrl.isDifferentDate(uso, $index)">
          {{$ctrl.textDayLabel(uso)}}
        </p>
        <div class="card-list" ng-repeat-end>
          <uib-accordion-group id="{{$ctrl.getUsoCardId(uso)}}" class="panel-default panel-aplicacoes aplicacoes-bg" is-open="uso.open">
            <uib-accordion-heading>
              <div class="default" prevent-event>
                <h3><b>{{uso.maquina.descricao}}</b></h3>
                <h5 class="text-cinza">
                  {{uso.operacao.descricao}} <span ng-show="uso.gleba">- {{uso.gleba.descricao}}</span>
                </h5>
              </div>
              <div class="arrow-expand-card text-cinza">
              <span ng-hide="uso.open">
                ver mais&nbsp;
                <i class="glyphicon pointer glyphicon-chevron-down"></i>
              </span>
              <span ng-show="uso.open">
                ver menos&nbsp;
                <i class="glyphicon pointer glyphicon-chevron-up"></i>
              </span>
              </div>
            </uib-accordion-heading>
            <p>
            <span ng-repeat="(key, value) in uso.organizedData" ng-if="value">
              {{key}}: <b>{{value}}</b> <br>
            </span>
            <button type="button" class="btn-xs btn-link text-info" ng-click="$root.openImageLightBox(uso.imagens)" ng-if="uso.imagens.length > 0">
              <span>Vizualizar imagem do hodômetro</span>
            </button>
            </p>
            <button type="button" class="btn-xs btn-link text-info" ng-click="$ctrl.showRastro(uso)" ng-disabled="uso.hasNoCoordinatesData">
              <span ng-if="uso.viewingRastro">Ocultar rastro da máquina</span>
              <span ng-if="!uso.viewingRastro && !uso.hasNoCoordinatesData">Exibir rastro da máquina</span>
              <span ng-if="uso.hasNoCoordinatesData">Não há rastro para exibir</span>
            </button>
          </uib-accordion-group>
        </div>
      </div>
    </uib-accordion>
  </div>
</div>
